import { LINKTREE_URL, EMAIL, scrollToSection } from "@/constants";

const SOCIALS = [
  { label: "LinkedIn", href: "https://www.linkedin.com/in/banksphillip", testid: "footer-linkedin-link" },
  { label: "Linktree", href: LINKTREE_URL, testid: "footer-linktree-link" },
  { label: "Facebook", href: "https://www.facebook.com/banksps1", testid: "footer-facebook-link" },
  { label: "X / Twitter", href: "https://www.twitter.com/banksps", testid: "footer-twitter-link" },
  { label: "Email", href: `mailto:${EMAIL}`, testid: "footer-email-link" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-[#D8D4CA]/70 pt-24 pb-12 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <button
          onClick={() => scrollToSection("#top")}
          data-testid="footer-back-to-top"
          className="font-display text-[13vw] lg:text-[10rem] leading-none tracking-tighter text-left w-full hover:text-primary transition-colors duration-500"
        >
          PHILLIP <span className="italic">BANKS</span> SR.
        </button>

        <p className="mt-10 text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-accent">
          AI · Professional Development · Technology Leadership · Speaking
        </p>

        <div className="mt-10 flex flex-col md:flex-row md:items-end justify-between gap-10">
          <div className="flex flex-wrap gap-x-10 gap-y-4">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target={s.href.startsWith("mailto") ? undefined : "_blank"}
                rel={s.href.startsWith("mailto") ? undefined : "noopener noreferrer"}
                data-testid={s.testid}
                className="text-sm tracking-wide text-foreground/70 hover:text-primary transition-colors duration-200"
              >
                {s.label}
              </a>
            ))}
          </div>
          <div className="text-sm text-foreground/50 space-y-1">
            <p>© {new Date().getFullYear()} Phillip Banks Sr.</p>
            <p>Technology Educator · Speaker · Consultant · Professional Development Leader</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
